import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {IVersionDetails} from "../interfaces/version.details";
import {VersionDetailsProxy} from "./version.details.proxy";
import {LogManager} from "../../log/log.manager";
import {takeUntilDestroy} from "take-until-destroy";
import {LogCat} from "../../log/log.categories";

@Injectable({
  providedIn: 'root'
})
export class VersionDetailsService implements OnDestroy {

  readonly defaultVersion = "11.5.0.0";
  readonly defaultProductLabelingState = "RNMD";
  public subject: BehaviorSubject<IVersionDetails>;

  constructor(private versionDetailsProxy: VersionDetailsProxy) {
    this.subject = new BehaviorSubject<IVersionDetails>(null);
  }
  ngOnDestroy() { }

  public load(): Observable<IVersionDetails> {
    this.versionDetailsProxy.getVersionDetails()
      .pipe(takeUntilDestroy(this))
      .subscribe(result => {
        const versionDetails: IVersionDetails = {
          buildDate:   new Date(result.buildDate),
          commercialVersion: result.commercialVersion,
          internalVersion: result.internalVersion,
          productLabelingState: result.productLabelingState
        };
        this.subject.next(versionDetails);
      }, (e) => {
        LogManager.error(LogCat.Login.VersionDetails, "Failed to get server version details taking default values", e);

        // Take the current datetime
        const buildDate = new Date();

        const versionDetails: IVersionDetails = {
          buildDate,
          commercialVersion: this.defaultVersion,
          internalVersion: this.defaultVersion,
          productLabelingState: this.defaultProductLabelingState
        };

        this.subject.next(versionDetails);
      });

    return this.subject.asObservable();
  }

  public getVersionDetails(): IVersionDetails {
    return this.subject.getValue();
  }
}
